import { render, staticRenderFns } from "./CredenciamentoRecursoContrarrazao.vue?vue&type=template&id=1d5d97ba"
import script from "./CredenciamentoRecursoContrarrazao.vue?vue&type=script&lang=js"
export * from "./CredenciamentoRecursoContrarrazao.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoRecursoContrarrazao.vue?vue&type=style&index=0&id=1d5d97ba&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports